"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/* eslint-disable complexity, max-statements */
var defaultNumberFormat = {
  decimalPlaces: 3,
  thousandsSeparator: ',',
  decimalMark: '.'
};
var defaultCurrencyFormat = {
  symbolFirst: true,
  withIsoCode: false,
  isoCode: 'USD',
  symbol: '$',
  decimalPlaces: 2
};

var NumberFormatter = /*#__PURE__*/function () {
  function NumberFormatter() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        currencyFormat = _ref.currencyFormat,
        numberFormat = _ref.numberFormat;

    _classCallCheck(this, NumberFormatter);

    this.numberFormat = _objectSpread(_objectSpread({}, defaultNumberFormat), numberFormat);
    this.currencyFormat = _objectSpread(_objectSpread({}, defaultCurrencyFormat), currencyFormat);
    this.percentageFormat = _objectSpread(_objectSpread({}, this.numberFormat), {}, {
      symbolFirst: false,
      symbol: '%'
    });
  }

  _createClass(NumberFormatter, [{
    key: "getNumberFormat",
    value: function getNumberFormat() {
      return this.numberFormat;
    }
  }, {
    key: "getCurrencyFormat",
    value: function getCurrencyFormat() {
      return this.currencyFormat;
    }
  }, {
    key: "getPercentageFormat",
    value: function getPercentageFormat() {
      return this.percentageFormat;
    }
  }, {
    key: "toNumber",
    value: function toNumber(formattedNumber) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$integerOnly = _ref2.integerOnly,
          integerOnly = _ref2$integerOnly === void 0 ? false : _ref2$integerOnly;

      if (typeof formattedNumber !== 'string' || formattedNumber === '') {
        return formattedNumber;
      }

      var delimiterRegex = new RegExp((this.numberFormat.thousandsSeparator === '.' ? '\\' : '') + this.numberFormat.thousandsSeparator, 'g');
      var output = formattedNumber.replace(delimiterRegex, '').replace(this.numberFormat.decimalMark, '.').replace(/ /g, '');

      if (isNaN(output)) {
        return output;
      } else if (integerOnly) {
        return ~~+output;
      }

      return +output;
    }
  }, {
    key: "formatNumber",
    value: function formatNumber(number) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$withDecimal = _ref3.withDecimal,
          withDecimal = _ref3$withDecimal === void 0 ? true : _ref3$withDecimal,
          _ref3$withRoundedDeci = _ref3.withRoundedDecimal,
          withRoundedDecimal = _ref3$withRoundedDeci === void 0 ? true : _ref3$withRoundedDeci,
          _ref3$decimalPlaces = _ref3.decimalPlaces,
          decimalPlaces = _ref3$decimalPlaces === void 0 ? this.numberFormat.decimalPlaces : _ref3$decimalPlaces;

      if (typeof number !== 'number') {
        return number;
      }

      var parts = Math.abs(number).toString().split('.');
      var isInteger = parts.length === 1;
      var isNegative = number < 0;

      var _parts = _slicedToArray(parts, 2),
          integerPart = _parts[0],
          fractionalPart = _parts[1];

      var output = '';

      for (var i = integerPart.length - 1, delimiterCount = 0; i >= 0; i--, delimiterCount++) {
        if (delimiterCount === 3) {
          output = "".concat(this.numberFormat.thousandsSeparator).concat(output);
          delimiterCount = 0;
        }

        output = "".concat(integerPart[i]).concat(output);
      }

      output = "".concat(isNegative ? '-' : '').concat(output);

      if (isInteger && !withDecimal || decimalPlaces === 0) {
        return output;
      }

      if (isInteger && withDecimal) {
        var zeroes = this.fill('', '0', decimalPlaces);
        return "".concat(output).concat(this.numberFormat.decimalMark).concat(zeroes);
      }

      var decimalValue = fractionalPart;

      if (withRoundedDecimal && decimalValue.length && decimalValue.length > decimalPlaces) {
        decimalValue = this.roundDecimal(decimalValue, decimalPlaces);
      }

      decimalValue = this.fill(decimalValue, '0', decimalPlaces);
      output += "".concat(this.numberFormat.decimalMark).concat(decimalValue);
      return output;
    }
  }, {
    key: "roundDecimal",
    value: function roundDecimal(decimal, decimalPlaces) {
      return Math.round("1.".concat(decimal) * Math.pow(10, decimalPlaces)).toString().substring(1);
    }
  }, {
    key: "fill",
    value: function fill(string, character, minimumLength) {
      var toTheRight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var result = string;

      while (result.length < minimumLength) {
        result = toTheRight ? "".concat(result).concat(character) : "".concat(character).concat(result);
      }

      return result;
    }
  }, {
    key: "formatCurrency",
    value: function formatCurrency(number) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$withDecimal = _ref4.withDecimal,
          withDecimal = _ref4$withDecimal === void 0 ? true : _ref4$withDecimal,
          _ref4$withRoundedDeci = _ref4.withRoundedDecimal,
          withRoundedDecimal = _ref4$withRoundedDeci === void 0 ? true : _ref4$withRoundedDeci,
          _ref4$withSymbol = _ref4.withSymbol,
          withSymbol = _ref4$withSymbol === void 0 ? true : _ref4$withSymbol;

      var _this$currencyFormat = this.currencyFormat,
          symbolFirst = _this$currencyFormat.symbolFirst,
          withIsoCode = _this$currencyFormat.withIsoCode,
          isoCode = _this$currencyFormat.isoCode,
          symbol = _this$currencyFormat.symbol,
          decimalPlaces = _this$currencyFormat.decimalPlaces;
      var baseNumber = this.formatNumber(number, {
        withDecimal: withDecimal,
        withRoundedDecimal: withRoundedDecimal,
        decimalPlaces: decimalPlaces
      });
      var formattedCurrency = symbol;
      if (!withSymbol) return baseNumber;

      if (symbolFirst) {
        if (baseNumber < 0) {
          formattedCurrency = "-".concat(formattedCurrency).concat(baseNumber.substr(1));
        } else {
          formattedCurrency += baseNumber;
        }
      } else {
        formattedCurrency = "".concat(baseNumber, " ").concat(formattedCurrency);
      }

      if (symbolFirst && withIsoCode && isoCode) {
        formattedCurrency += " ".concat(isoCode);
      }

      return formattedCurrency;
    }
  }, {
    key: "formatPercentage",
    value: function formatPercentage(number) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref5$withDecimal = _ref5.withDecimal,
          withDecimal = _ref5$withDecimal === void 0 ? true : _ref5$withDecimal,
          _ref5$withRoundedDeci = _ref5.withRoundedDecimal,
          withRoundedDecimal = _ref5$withRoundedDeci === void 0 ? true : _ref5$withRoundedDeci;

      var baseNumber = this.formatNumber(number, {
        withDecimal: withDecimal,
        withRoundedDecimal: withRoundedDecimal,
        decimalPlaces: this.percentageFormat.decimalPlaces
      });
      var format = this.percentageFormat;
      return format.symbolFirst ? "".concat(format.symbol).concat(baseNumber) : "".concat(baseNumber).concat(format.symbol);
    }
  }]);

  return NumberFormatter;
}();

exports["default"] = NumberFormatter;